import { configureStore } from '@reduxjs/toolkit';
import dealReducer from './slices/dealSlice';
import authReducer from './reducers/authReducer';
import errorReducer from './reducers/errorReducer';
import postReducer from './reducers/postReducer';

export const store = configureStore({
  reducer: {
    deals: dealReducer,
    auth: authReducer,
    errors: errorReducer,
    post: postReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

// Export types for TypeScript support (commented out for JS)
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;

export default store;
